import styled from 'styled-components';

import { TextButtonBase } from '@ad-scripts/presentation/components/common/button';

const PlainTextButton = styled.button`
  ${TextButtonBase};
  color: ${p => p.theme.colors.green400};
  padding: 4px 36px;

  &:hover,
  &:active {
    background: transparent;
    color: ${p => p.theme.colors.green400};
  }
`;

export default PlainTextButton;
